import React from 'react';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import { ServiceItem } from './ServiceItem';
import { useHomeStrings } from '../../hooks/useHomeStrings';
import type { HomeService } from '../../model/types';

interface Props {
  services: HomeService[];
  servicesTotal: number;
  showPrice: boolean;
}

const MAX_PREVIEW = 5;

export const ServicesPreview: React.FC<Props> = ({ services, servicesTotal, showPrice }) => {
  const STRINGS = useHomeStrings();
  const navigate = useNavigate();
  const preview = (services ?? []).slice(0, MAX_PREVIEW);

  if (preview.length === 0) return null;

  return (
    <div
      style={{
        margin: '0 16px 12px',
        borderRadius: 'var(--bl-radius-lg)',
        background: 'var(--bl-surface)',
        border: '1px solid var(--bl-divider)',
        padding: '14px 16px',
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 10,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Typography.Text
            style={{ fontWeight: 600, fontSize: 17, color: 'var(--bl-text)' }}
          >
            {STRINGS.SERVICES_TITLE}
          </Typography.Text>
        </div>
        {servicesTotal > MAX_PREVIEW && (
          <button
            type="button"
            onClick={() => navigate('/booking/new/0')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 3,
              background: 'none',
              border: 'none',
              padding: '12px 4px',
              minHeight: 44,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            <Typography.Text
              style={{ fontSize: 13, color: 'var(--bl-primary)', fontWeight: 500 }}
            >
              {STRINGS.SERVICES_SEE_ALL(servicesTotal)}
            </Typography.Text>
            <RightOutlined style={{ fontSize: 10, color: 'var(--bl-primary)' }} />
          </button>
        )}
      </div>

      {/* Items */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {preview.map((svc) => (
          <ServiceItem
            key={svc.id}
            service={svc}
            showPrice={showPrice}
            onClick={() => navigate(`/booking/new/0?preselectServiceId=${svc.id}`)}
          />
        ))}
      </div>
    </div>
  );
};
